import { Route, useLocation, useHistory } from 'react-router-dom';
import { getJwtToken, validateJWT } from 'lib/src/utils/jwt';
import { userRoles } from 'lib/src/shared/enums/dropdownEnums';
import useRoles from 'lib/src/hooks/useRoles';

const SubRouter: React.FC<SubRouterProps> = ({
    path,
    children,
    auth = false,
    exact = false,
    requiredRole,
}) => {
    const location = useLocation();
    const history = useHistory();
    const curUserRoles = useRoles();

    if (auth) {
        const token = getJwtToken();

        const isValidToken = token ? validateJWT(token) : false;
        const isSuperAdmin = curUserRoles.includes(userRoles.superAdmin);
        const isAdmin = isSuperAdmin || curUserRoles.includes(userRoles.admin);
        let hasCorrectRole = true;
        if (requiredRole) {
            if (!Array.isArray(requiredRole)) {
                requiredRole = [requiredRole];
            }
            hasCorrectRole = isSuperAdmin || requiredRole.some(role => curUserRoles.includes(role));
        }
        if (!isValidToken || !isAdmin || !hasCorrectRole) {
            history.replace('/auth/login', { from: location });
            return null;
        }
    }
    return (
        <Route exact={exact} path={path}>
            {children}
        </Route>
    );
};

interface SubRouterProps {
    children: React.ReactNode;
    path: string;
    auth?: boolean;
    exact?: boolean;
    requiredRole?: userRoles | userRoles[];
}

export default SubRouter;
